import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { getServices } from '../../../app/services'
import { getStep, nextStep, resetStep, updateSteps } from '../../steps'
import { getCurrentRegion, updateOrder } from '../../order'
import ImmutablePropTypes from 'react-immutable-proptypes'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Service from './service/Service'
import styles from './css/Service.scss'
import ValidationErrors from '../../components/ValidationErrors'
import { withRouter } from 'react-router-dom'
import Immutable from 'immutable'
import OptionalMessage from '../../../app/components/OptionalMessage'

export class ServiceStep extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        order: ImmutablePropTypes.map.isRequired,
        region: ImmutablePropTypes.map.isRequired,
        services: ImmutablePropTypes.map.isRequired,
        step: ImmutablePropTypes.map.isRequired,
        tenant: ImmutablePropTypes.map,
    }

    componentWillMount () {
        window.scrollTo(0, 0)
        this.props.dispatch(getServices())
    }

    handleNextStep = () => {
        const { step, dispatch } = this.props
        dispatch(nextStep(step))
    }

    handleServiceSelect = (service) => {
        const { order, dispatch, step, steps } = this.props

        if (order.get('service') !== service) {
            const newOrder = order.set('service', service).set('positions', Immutable.fromJS({})).set('location', null)
            const newSteps = steps.setIn(['position', 'state'], 'incomplete').setIn(['shipping', 'state'], 'incomplete').setIn(['summary', 'state'], 'incomplete').setIn(['confirmation', 'state'], 'incomplete')
            dispatch(updateOrder(newOrder))
            dispatch(updateSteps(newSteps))
        }

        dispatch(resetStep('position'))
        dispatch(nextStep(step))
    }

    render () {
        const { services, order, step, region } = this.props
        const list = services
        .filter(service => (
            service.get('alias') !== 'service.exchange'
            || !!region.get('exchangeService')
        ))
        .map((service, index) => (
            <Service
                key={index}
                service={service}
                selected={order.get('service') === service.get('id')}
                handleServiceSelect={this.handleServiceSelect}
            />
        )).toArray()

        return (
            <div className={styles.container}>
                <h1><FormattedMessage id={'frontend.form_selector_service.headline'}/></h1>

                <ValidationErrors
                    errors={step.get('errors')}
                    status={step.get('state')}
                >
                    <FormattedMessage id="frontend.form_selector_region.validation"/>
                </ValidationErrors>

                <OptionalMessage slug="service_hint" />

                <div className={styles.content}>
                    <div className={styles.services}>
                        {list}
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(connect(state => ({
    order: state.order,
    services: state.services,
    step: getStep(state, 'service'),
    steps: state.steps,
    region: getCurrentRegion(state),
    tenant: state.tenant,
}))(ServiceStep))
